export default __webpack_public_path__ + "static/media/lf1.2153fd79.jpg";